import { SendOutlined } from '@ant-design/icons';
import { Button, TextAreaAndImage, Multimedia } from '@clockout-dev/design-elements';
import styles from '../styles/ticket.module.scss';
import { SupportTicketConstants } from '../support.enums';

function TicketMessageInput({ replyBody, replySending, replyAttachments = [], onReplyBodyChange, onReplyAttachmentsChange, onSendReply }) {
    const hasContent = Boolean((replyBody || '').trim()) || replyAttachments.length > 0;

    return (
        <div className={styles.composerCard}>
            <div className={styles.composerInner}>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '8px' }}>
                    <TextAreaAndImage
                        className={styles.textarea}
                        size="m"
                        rows={2}
                        placeholder="Type your message here…"
                        value={replyBody}
                        onChange={(e) => onReplyBodyChange(e.target.value)}
                        onFilesChange={(entries) => onReplyAttachmentsChange?.(entries)}
                        maxLength={SupportTicketConstants.BODY_MAX_LENGTH}
                        showButton
                        showCount
                    />
                    {replyAttachments.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {replyAttachments.map((att, i) => (
                                <Multimedia
                                    key={`${att.name}-${i}`}
                                    src={att.url}
                                    name={att.name}
                                    type={att.type}
                                    onRemove={() => onReplyAttachmentsChange?.(replyAttachments.filter((_, idx) => idx !== i))}
                                />
                            ))}
                        </div>
                    )}
                </div>
                <Button
                    type="button"
                    variant="primary"
                    color="secondary"
                    size="l"
                    fontWeight="semibold"
                    className={styles.sendBtn}
                    disabled={replySending || !hasContent}
                    onClick={onSendReply}
                >
                    <span className={styles.sendBtnContent}>
                        <SendOutlined />
                        {replySending ? 'Sending...' : 'Send reply'}
                    </span>
                </Button>
            </div>
        </div>
    );
}

export default TicketMessageInput;
